import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import DeleteIcon from '@/assets/refund/bin.png';
import CustomModal from '../common/CustomModal';
import { useMutation, useQueryClient } from 'react-query';
import { refundCancle } from '@/api/refund';
import { AxiosError } from 'axios';
import { IRefundCanclePayload, IRefundDetailContent } from '@/types/refund';
import FlexWrap from '../common/FlexWrap';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { convertToKoreanUnit, getComma } from '@/util/format';
import { useGetPaymentStatusForCancel } from '@/hooks/useGetPaymentStatusForCancel';
import PaymentCancelErrorModal from '../globalPayment/PaymentCancelError.modal';

type Props = {
  refund: IRefundDetailContent;
  isCanceled?: boolean;
  isCancelDisable?: boolean;
};
function DiscountCancelButton({ refund, isCanceled, isCancelDisable }: Props) {
  const {
    nation,
    refund: refundPrice,
    refundIndex,
    supplyDate,
    totalPrice,
    touristPassportNumber,
    qrOrderId,
  } = refund;
  const queryClient = useQueryClient();

  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [isDisabledButton, setIsDisabledButton] = useState(false);
  const [isOpenNonCancelledModal, setIsOpenNonCancelledModal] = useState(false);
  const [isOpenCompleteModal, setIsOpenCompleteModal] = useState(false);
  const { hospitalId } = useAppSelector((state) => state.user);
  const [isPaymentCancelErrorModalOn, setIsPaymentCancelErrorModalOn] =
    useState(false);

  const [isPaymentCancelInfoModalOn, setIsPaymentCancelInfoModalOn] =
    useState(false);
  const { paymentStatus, checkPaymentStatus, isLoading } =
    useGetPaymentStatusForCancel({
      qrOrderId: qrOrderId?.toString(),
    });

  const refundCancelMutation = useMutation<
    null,
    AxiosError,
    IRefundCanclePayload
  >('refundCancel', (payload) => refundCancle(payload), {
    retry: false,
    onSuccess: () => {
      setIsDisabledButton(false);
      onOpenDeleteModal();
      setIsOpenCompleteModal(true);
      queryClient.invalidateQueries('refundDetail');
    },
    onError: (error) => {
      if ((error.response as any).data.code === 'R0012') {
        setIsOpenNonCancelledModal(true);
      }

      setIsDisabledButton(false);
      console.log('에러', error);
    },
  });

  const onOpenDeleteModal = async () => {
    if (qrOrderId) {
      const res = await checkPaymentStatus();
      console.log('결제 상태 확인 결과:', res);
      setIsPaymentCancelInfoModalOn(true);
    } else {
      setIsDeleteModal((prev) => !prev);
    }
  };
  const onClickRefundCancel = () => {
    setIsDisabledButton(true);
    refundCancelMutation.mutate({ cancelList: [refundIndex] });
  };

  return (
    <>
      {!isCanceled && (
        <DeleteBtn
          onClick={() => {
            if (isCancelDisable) {
              setIsPaymentCancelErrorModalOn(true);
            } else {
              onOpenDeleteModal();
            }
          }}
          isCancelDisable={isCancelDisable}
        >
          <DeleteImg src={DeleteIcon} />
        </DeleteBtn>
      )}

      <PaymentCancelErrorModal
        isOpen={isPaymentCancelErrorModalOn}
        desc={
          '해당 건은 환급금 수령이 완료되어 직접 취소가 불가합니다.\n취소를 원하시면 채팅 혹은 전화로 문의 부탁드립니다.'
        }
        onClose={() => {
          setIsPaymentCancelErrorModalOn(false);
        }}
      />

      {isDeleteModal && (
        <Wrapper>
          <CustomModal
            title='할인건 취소하기'
            desc='할인을 취소할까요?'
            btnTitle='취소하기'
            subBtnTitle='닫기'
            btnDisabled={isDisabledButton}
            onClickSubBtn={onOpenDeleteModal}
            onClickBtn={onClickRefundCancel}
            mainBtnColor={'#FF2D55'}
            contentElement={
              <ContentContainer dir='column'>
                시술일자 {supplyDate}
                <br />
                국적 {nation}
                <br />
                결제 금액
                {getComma(+totalPrice - +refundPrice)}
                원
                <br />
                할인액 {getComma(refundPrice)}원
              </ContentContainer>
            }
          />
        </Wrapper>
      )}
    </>
  );
}
export default DiscountCancelButton;
const DeleteImg = styled.img`
  width: 18px;
  height: 18px;
`;
const DeleteBtn = styled.button<{ isCancelDisable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  opacity: ${(props) => (props.isCancelDisable ? 0.17 : 1)};

  &:hover {
    border-color: ${(props) =>
      !props.isCancelDisable ? '#e9f0fe' : 'transparent'};
    background-color: ${(props) =>
      !props.isCancelDisable ? '#e9f0fe' : 'transparent'};
  }
`;

const ContentContainer = styled(FlexWrap)`
  background-color: ${(props) => props.theme.mono[5]};
  border-radius: 4px;
  padding: 12px;
  color: ${(props) => props.theme.mono[65]};
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  text-align: left;
  color: #030303;
`;
const PaymentCancelInfoContainer = styled(FlexWrap)`
  padding-top: 24px;
  gap: 12px;
`;

const ContentRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: #3a3b3e;
  text-align: right;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const ContentName = styled.div`
  color: #80848a;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.32px;
`;
